import { DesignSearchParams, DesignSearchResponse } from '@/types';
import { convertSprdLocaleToSprdIsoLocale } from '@/utils/convertSprdLocaleToIsoLocale';
import { getParams } from '@/utils/params';
import { getRequest } from './methods/getRequest';
import { requestToJSON } from './methods/requestToJSON';
import { addParamsToUrl } from './methods/urlParams';

export const fetchCYODesigns = (params: DesignSearchParams, signal?: AbortSignal) =>
  requestToJSON<DesignSearchResponse>(
    getRequest(
      addParamsToUrl(
        `/search/omat/${convertSprdLocaleToSprdIsoLocale(getParams().locale)}/marketplace/designs`,
        params
      ),
      { signal }
    )
  );
